export default [
  {
    path: '/agenda',
    name: 'agenda',
    component: () => import(/* webpackChunkName: "agenda" */ '../../views/agenda/Agenda')
  },
  {
    path: '/agenda/eventos',
    name: 'listagem-eventos',
    component: () => import(/* webpackChunkName: "agenda" */ '../../views/agenda/Eventos')
  },
  {
    path: '/agenda/cadastro',
    name: 'cadastro-eventos',
    component: () => import(/* webpackChunkName: "cadastro-eventos" */ '../../views/agenda/Cadastro')
  },
  {
    path: '/agenda/cadastro/:id',
    name: 'edicao-eventos',
    component: () => import(/* webpackChunkName: "edicao-eventos" */ '../../views/agenda/Cadastro')
  },
  {
    path: '/agenda/convites',
    name: 'listagem-convites',
    component: () => import(/* webpackChunkName: "listagem-convites" */ '../../views/agenda/Convites')
  }
]
